import { useState, useEffect, useCallback } from 'react';

const MAX_ITEMS = 8;

const getStorageKey = (storeSlug) => `magere_recently_viewed_${storeSlug}`;

const getRecentlyViewed = (storeSlug) => {
  try {
    const raw = localStorage.getItem(getStorageKey(storeSlug));
    return raw ? JSON.parse(raw) : [];
  } catch { return []; }
};

export const useRecentlyViewed = (storeSlug) => {
  const [items, setItems] = useState(() => getRecentlyViewed(storeSlug));

  useEffect(() => {
    setItems(getRecentlyViewed(storeSlug));
  }, [storeSlug]);

  const trackProduct = useCallback((product) => {
    if (!product?.id || !storeSlug) return;
    const entry = {
      id: product.id,
      name: product.name,
      slug: product.slug,
      price: product.price,
      sale_price: product.sale_price,
      featured_image: product.featured_image,
      images: product.images?.slice(0, 1),
      category: product.category,
      is_promo: product.is_promo,
    };
    const prev = getRecentlyViewed(storeSlug).filter(p => p.id !== product.id);
    const updated = [entry, ...prev].slice(0, MAX_ITEMS);
    localStorage.setItem(getStorageKey(storeSlug), JSON.stringify(updated));
    setItems(updated);
  }, [storeSlug]);

  return { recentlyViewed: items, trackProduct };
};
